import {
  BatchStatisticsReserveBestConditionListItem,
  BatchStatisticsReserveBestConditionListItemFromJSON
} from '@/api/models/batch/BatchStatisticsReserveBestConditionListItem'

export interface BatchStatisticsReserveBestSelectItemResult {
  items: BatchStatisticsReserveBestConditionListItem
}

export function BatchStatisticsReserveBestSelectItemResultFromJSON(
  json: any
): BatchStatisticsReserveBestSelectItemResult {
  return {
    items: BatchStatisticsReserveBestConditionListItemFromJSON(json)
  }
}
